import i18n from '@/language/i18n';

const WORK_CALENDAR_TYPES = Object.freeze({
    FULL_WEEK: { value: [1, 2, 3, 4, 5, 6, 0], text: i18n.t('Calendar.periodSelector.selections.fullWeek') },
    WIHTOUT_WEEKEND: { value: [1, 2, 3, 4, 5], text: i18n.t('Calendar.periodSelector.selections.withoutWeekends') },
    ONLY_WEEKENDS: { value: [6, 0], text: i18n.t('Calendar.periodSelector.selections.onlyWeekends') },
});

export default WORK_CALENDAR_TYPES;
